import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Copy, Heart } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { PageHeader, Empty } from "@/components/kit";
import { logError } from "@/lib/log";

const copy = async (q) => {
  try { await navigator.clipboard.writeText(`“${q.text}” — ${q.author}`); toast.success("Copied"); }
  catch { toast.error("Could not copy"); }
};

const Card = ({ q, i, onRemove }) => (
  <div className="mm-card p-5 mm-fade-up" data-testid={`saved-quote-${i}`}>
    <p className="font-display text-lg leading-snug">“{q.text}”</p>
    <div className="flex items-center justify-between gap-2 mt-3">
      <span className="text-sm text-mm-muted">— {q.author}</span>
      <div className="flex gap-1">
        <button onClick={() => copy(q)} className="p-2 rounded-full hover:bg-mm-surface-light transition-colors" aria-label="Copy quote" data-testid={`saved-quote-copy-${i}`}><Copy size={16} /></button>
        <button onClick={() => onRemove(q)} className="p-2 rounded-full text-mm-error hover:bg-mm-surface-light transition-colors" aria-label="Remove from saved" data-testid={`saved-quote-remove-${i}`}><Heart size={16} fill="currentColor" /></button>
      </div>
    </div>
  </div>
);

export default function SavedQuotes() {
  const [list, setList] = useState(null);
  useEffect(() => { api.get("/quotes/saved").then((r) => setList(r.data)).catch((e) => { logError("Saved quotes failed:", e); setList([]); }); }, []);

  const remove = async (q) => {
    setList((l) => l.filter((x) => x.text !== q.text));
    try { await api.post("/quotes/saved/remove", { text: q.text }); toast.success("Removed from saved"); }
    catch (e) { toast.error(errMsg(e)); setList((l) => [q, ...l]); }
  };

  return (
    <div data-testid="saved-quotes-page">
      <PageHeader title="Saved quotes" subtitle={list?.length ? `${list.length} quote${list.length === 1 ? "" : "s"} that spoke to you` : "Quotes that spoke to you"} />
      {list === null ? null : list.length ? (
        <div className="space-y-3">{list.map((q, i) => <Card key={q.text} q={q} i={i} onRemove={remove} />)}</div>
      ) : (
        <div data-testid="saved-quotes-empty">
          <Empty emoji="💜" title="No saved quotes yet" text="Tap the heart on Home's quote of the day to keep the ones you love here." cta="Go to Home" to="/" />
        </div>
      )}
    </div>
  );
}
